import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballTeamService } from "../../../../../../../commons";
import { StatusEnum } from "../../../../../../../commons/enums/status-enum";
import { FootballTeamPlayer } from "../../../../../../../commons/models/football/football-team-player";
import { EnsueCollection } from "../../../../../../../ensue-react-system/utilities/ensue-collection";

export interface IManageSubTeamPlayersState {
  manageSubTeamPlayersList: EnsueCollection<FootballTeamPlayer>;
  manageSubTeamPlayersListStatus: StatusEnum;
}

export interface IManageSubTeamPlayersOption {
  teamId: number;
  subTeamId: number;
  urlParams?: {
    page?: number;
    perPage?: number;
    sort?: string;
    sortOrder?: "DESC" | "ASC";
    name?: string;
    isFeatured?: boolean;
  };
}

const initialState: IManageSubTeamPlayersState = {
  manageSubTeamPlayersList: new EnsueCollection<FootballTeamPlayer>(),
  manageSubTeamPlayersListStatus: StatusEnum.Idle,
};

export const fetchManageSubTeamPlayerList = createAsyncThunk(
  "manage/subTeamPlayerList",
  async (options: IManageSubTeamPlayersOption, thunkAPI) => {
    try {
      const manageSubTeamPlayersList = await manageFootballTeamService.getSubTeamPlayers(
        options.teamId,
        options.subTeamId,
        options.urlParams
      );
      return manageSubTeamPlayersList;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageSubTeamPlayerListSlice = createSlice({
  name: "subTeamPlayerList",
  initialState: initialState,
  reducers: {
    cleanUpManageSubTeamPlayers(state) {
      state.manageSubTeamPlayersList = new EnsueCollection<FootballTeamPlayer>();
      state.manageSubTeamPlayersListStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageSubTeamPlayerList.pending, (state) => {
        state.manageSubTeamPlayersListStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageSubTeamPlayerList.fulfilled,
        (state, action: PayloadAction<EnsueCollection<FootballTeamPlayer>>) => {
          state.manageSubTeamPlayersListStatus = StatusEnum.Succeeded;
          state.manageSubTeamPlayersList = action.payload;
        }
      )
      .addCase(fetchManageSubTeamPlayerList.rejected, (state) => {
        state.manageSubTeamPlayersListStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpManageSubTeamPlayers } = manageSubTeamPlayerListSlice.actions;
export default manageSubTeamPlayerListSlice.reducer;
